import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableFreightCustomAttributes = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableFreightCustomAttributes);
};
